export const api = {
    carEnterManage: {
        queryVehicleAppointmentList: '/bms/queryVehicleAppointment/queryVehicleAppointmentList',
        passVehicleAppointment: '/bms/addVehicleAppointment/passVehicleAppointmentOut',
        refuseVehicleAppointment: '/bms/addVehicleAppointment/refuseVehicleAppointment',
        exportVehicleAppointmentWorkList: '/bms/queryVehicleAppointment/exportVehicleAppointmentWorkList.json',
    },
    exitApproval: {
        queryVehicleAppointmentOutList: '/bms/queryVehicleAppointment/queryVehicleAppointmentOutList',
        queryVehicleAppointmentOut: '/bms/queryVehicleAppointment/queryVehicleAppointmentOut',
    }
}
